import { connectorsForWallets, getDefaultConfig } from '@rainbow-me/rainbowkit'
import { mainnet, sepolia } from 'wagmi/chains'
import {
  metaMaskWallet,
  coinbaseWallet,
  rainbowWallet,
  walletConnectWallet,
  rabbyWallet,
  phantomWallet,
  okxWallet,
  binanceWallet,
  injectedWallet
} from '@rainbow-me/rainbowkit/wallets'

import { isEnvProduction } from '../../util/app.helpers'

const isEnvProd = isEnvProduction() || true // @TODO Enforcing prod for now

const chains = [mainnet, sepolia]

const appConfig = {
  projectId: process.env.REACT_APP_WALLET_PROJECT_ID,
  appName: '$QBX claiming & staking',
  appDescription:
    'The most rewarding Web3 loyalty program. Claim and stake your QBX.',
  appUrl: 'https://claim.qiibeefoundation.org/',
  appIcon: 'https://vip.qiibeefoundation.org/assets/icons/qbx.png'
}

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Popular',
      wallets: [
        injectedWallet,
        metaMaskWallet,
        coinbaseWallet,
        rainbowWallet,
        walletConnectWallet,
        rabbyWallet,
        phantomWallet,
        okxWallet,
        binanceWallet
      ]
    }
  ],
  appConfig
)

const getWagmiConfig = getDefaultConfig({
  ...appConfig,
  connectors,
  chains,
  batch: { multicall: true },
  ssr: false
})

const getChain = () => {
  return isEnvProd ? mainnet : sepolia
}

export { getWagmiConfig, getChain }
